import React, {useState} from 'react';
import UIToggleButton from '../ui/UIToggleButton';

import Anchor from '../data/Anchor';
import Color from '../data/Color';
import Size from '../data/Size';
import UIButton, { UIButtonWPopup } from '../ui/UIButton';

import Flex from '../data/Flex';
import UITitle from '../ui/UITitle';
import UIIcon from '../ui/UIIcon';
import UIInput from '../ui/UIInput';
import UIContainer, {UIWhiteBox } from '../ui/UIContainer';
import UIStatusBanner, { IStatus } from '../ui/UIStatusBanner';
import useValueName from '../hooks/useValueName';
import View from './View';
import { UIAutoComplete } from '../ui/UIAutoComplete';

interface IComponentTestViewState{
    username:string;
    password:string;
    amount:number;
    desc:string;
    toggle1:boolean;
    movie:string;
    easyMode:boolean;
}

export interface IComponentTestViewProps {
}



ComponentTestView.ID = "components";
ComponentTestView.TITLE = "Components";
ComponentTestView.PATH = "components";

export default function ComponentTestView($props:IComponentTestViewProps){


    const [vnValues, setValue] = useValueName({
        username:"",
        password:"",
        desc:"",
        amount:0, 
        movie:"", 
        toggle1:false,
        easyMode:false,
    });

    const vnState:IComponentTestViewState = vnValues;

    let statusData:IStatus[] = [
        {
            id:"didsomethingsuccess",
            content:"Success something something darkside",
            type:UIStatusBanner.TYPE_SUCCESS
        },
        {
            id:"didsomethingerror",
            content:"Error uh oh",
            type:UIStatusBanner.TYPE_ERROR
        },
        {
            id:"didsomethingwarning",
            content:"Warning Message",
            type:UIStatusBanner.TYPE_WARNING
        },
        {
            id:"didsomethinginfo",
            content:"Information something",
            type:UIStatusBanner.TYPE_INFO
        }
    ];

    const [statuses, setStatuses] = useState(statusData);
    
    const addStatus=($type:string, $content:string | JSX.Element, $id:string)=>{
        
        let statusesnew = [...statuses];
        statusesnew.push({
            id:$id,
            content:$content,
            type:$type,
        });

        setStatuses(statusesnew);
    }


    return (
        <View id={ComponentTestView.ID} flex={{}}>
            <UIContainer padding>
                <UIWhiteBox marginBottom>
                    <UITitle marginBottom title="White Box Container"/>
                </UIWhiteBox>
                <UIWhiteBox marginBottom>
                    <UITitle marginBottom title="Buttons"/>
                    <UIContainer>
                        <UIButton label="Button"/>
                        <UIButton dropShadow noPadding label="Btn No Pad"/>
                        <UIButton dropShadow label="Refresh" icon={UIIcon.RELOAD} color={Color.WHITE}/>
                        <UIButton label="Refresh" icon={UIIcon.RELOAD} color={Color.WHITE_PRIMARY}/>
                        <UIButton label="GREY" color={Color.GREY}/>
                        <UIButton label="GREY DISABLED" color={Color.GREY} disabled/>
                        <UIButton isSquare icon={UIIcon.SEARCH_LOCATION} size={Size.s36} />
                        <UIButton label="Button 16" size={Size.s16} />
                        <UIButton label="Button 20" size={Size.s20} />
                        <UIButton label="Button 30" size={Size.s30} />
                        <UIButton label="Button 30 Disabled" size={Size.s30} disabled />
                        <UIButton label="Button 40" size={Size.s40} />
                        <UIButton label="Button 50" size={Size.s50} />
                        <UIButton label="Button 60" size={Size.s60} />
                        <UIButton label="Button 66" size={Size.s66} />
                        <UIButton flex={{justifyContent:Flex.CENTER, direction:Flex.COLUMN}}  label="Button 70" size={Size.s70} />
                        <UIButton dropShadow label="I like your sleeves. They're real big." icon={UIIcon.CLOSE} color={Color.GREY} fontSize={Size.s26} size={Size.s60}/>
                        <UIButton icon={UIIcon.EDIT} label="Btn w Icon"/>
                        <UIButton icon={UIIcon.SEARCH_LOCATION} label="Btn w Icon Vertical" flex={{direction:Flex.COLUMN}}/>
                        <UIButton noPadding icon={UIIcon.RELOAD} label="Btn w Icon ROW REVERSE" flex={{direction:Flex.ROW_REVERSE}}/>
                        <UIButton icon={UIIcon.ADD} label="Btn w Icon COL REVERSE"flex={{direction:Flex.COLUMN_REVERSE}}/>
                    </UIContainer>
                </UIWhiteBox>
                <UIWhiteBox marginBottom>
                    <UITitle marginBottom title="Status Banners"/>
                    <UIContainer flex={{direction:Flex.COLUMN}}>
                        <UIContainer flex={{direction:Flex.ROW, alignItems:Flex.CENTER}}>
                            <UITitle fontSize={Size.s14} notBold title={"Add more:"}/>
                            <UIButton label={"Success"} onClick={()=>{
                                addStatus(UIStatusBanner.TYPE_SUCCESS,"Something Successful","successYo"+Date.now());
                            }}/>
                            <UIButton label={"Warning"} onClick={()=>{
                                addStatus(UIStatusBanner.TYPE_WARNING,"Warning Yo","warningYo"+Date.now());
                            }}/>
                            <UIButton label={"Error"} onClick={()=>{
                                addStatus(UIStatusBanner.TYPE_ERROR,"Somebodies poisoned the water well","errorYo"+Date.now());
                            }}/>
                            <UIButton label={"Info"} onClick={()=>{
                                addStatus(UIStatusBanner.TYPE_INFO,"Something Informative","infoYo"+Date.now());
                            }}/>
                        </UIContainer>
                        {statuses.map(($status,$index)=>{
                            return <UIStatusBanner status={$status} key={$status.id+"statusBanner"} onClose={($closingStatus:IStatus)=>{
                                let statusIndex = statuses.findIndex(($status)=>{
                                    return $status.id===$closingStatus.id;
                                });
                                if(statusIndex!==-1){
                                    let statusesnew = [...statuses];
                                    statusesnew.splice(statusIndex,1);
                                    setStatuses(statusesnew);
                                }
                            }}  />
                        })}
                    </UIContainer>
                </UIWhiteBox>
                <UIWhiteBox marginBottom>
                    <UITitle marginBottom title="Inputs"/>
                    <UIContainer>
                        <UIInput name='username' size={Size.s70} valueExtra={(<UIButton fontSize={Size.s20} isSquare icon={UIIcon.SEARCH_LOCATION}/>)} isRequired label="Username" placeholder='' value={vnState.username} onChange={setValue} />
                        <UIInput name='password' style={UIInput.STYLE_LABEL_AS_PLACEHOLDER} isRequired label="Password"  placeholder='' type="password" value={vnState.password} onChange={setValue} />
                        <UIInput name='number' label="Number"  placeholder='Enter a number' value={vnState.amount} onChange={setValue} />
                        <UIInput name='desc' label="Description"  placeholder='Describe something' type="textarea" value={vnState.desc} onChange={setValue} />
                        <UIInput name='movie' options={[
                            {label:"SELECT",value:""},
                            {label:"The Matrix", value:"theMatrix"},
                            {label:"The Big Lebowsky", value:"thebiglebowski"},
                            {label:"Starship Troopers", value:"starshiptroopers"},
                            {label:"The Lord of the Rings", value:"lotr"},
                        ]} label="Movies" type={UIInput.TYPE_SELECT} value={vnState.movie} onChange={setValue} />
                        <UIInput name="easyMode" label="Checkbox" type={UIInput.TYPE_CHECKBOX} value={vnState.easyMode} onChange={setValue} />
                        <UIInput name="easyMode" type={UIInput.TYPE_CHECKBOX} value={vnState.easyMode} onChange={setValue} />
                    </UIContainer>
                </UIWhiteBox>
                <UIWhiteBox marginBottom>
                    <UITitle marginBottom title="Toggle Buttons"/>
                    <UIContainer>
                        <UIToggleButton name="toggle1" onChange={setValue} enabled={vnState.toggle1}/>
                        <UIToggleButton yesLabel='Tall' size={Size.s70} name="toggle1" onChange={setValue} enabled={vnState.toggle1}/>
                        <UIToggleButton yesLabel='Tiny' flex={{style:{width:50}}}  fontSize={Size.s10} dragFontSize={Size.s14} dragWidth={24} size={Size.s20} name="toggle1" onChange={setValue} enabled={vnState.toggle1}/>
                        <UIToggleButton yesLabel='WIIIIDDDDEEE' flex={{style:{width:300}}} name="toggle1" onChange={setValue} enabled={vnState.toggle1}/>
                    </UIContainer>
                </UIWhiteBox>
                <UIWhiteBox>
                    <UITitle marginBottom title="Popups"/>
                    <UIContainer>
                        <UIButtonWPopup button={{label:"Bottom Center"}} popup={{anchor:Anchor.BOTTOM_CENTER}}>
                            Default
                        </UIButtonWPopup>                        
                        <UIButtonWPopup button={{label:"Bottom Left"}} popup={{anchor:Anchor.BOTTOM_LEFT, flex:{style:{width:200}}}}>
                            200 px
                        </UIButtonWPopup>                      
                        <UIButtonWPopup 
                            button={{label:"Bottom Right"}} 
                            popup={
                                {
                                    anchor:Anchor.BOTTOM_RIGHT, 
                                    flex:{
                                        alignItems:Flex.FLEX_END,
                                        style:{
                                            width:300,
                                        }
                                    }
                                }
                            }>
                            WIDE and right aligned
                        </UIButtonWPopup>
                    </UIContainer>
                </UIWhiteBox>
                <UIWhiteBox>
                    <UITitle marginBottom title="Auto Complete"/>
                    <UIContainer flex={{direction:Flex.COLUMN}}>
                        <UIAutoComplete name="testyyyyy" data={[
                            {id:"matrix", label:"Matrix"},
                            {id:"matrix2", label:"Matrix 2"},
                            {id:"matrix3", label:"Matrix 3"},
                            {id:"avengers", label:"The Avengers"},
                            {id:"mummy", label:"The Mummy"},
                            {id:"mummy2", label:"The Mummy 2"},
                            {id:"mummy3", label:"The Mummy 3"},
                        ]}/>
                        <div>auto complete should appear over me</div>
                    </UIContainer>
                </UIWhiteBox>

            </UIContainer>
        </View>
    );
}
